import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FeedbackService} from '../_service/service.service';
import {CurrentUserDataService} from '../../../shared/_services/current-user-data.service';
import {Feedback} from '../_models/feedback.model';

@Component({
    selector: 'app-view-feedback',
    templateUrl: './view-feedback.component.html',
    styleUrls: ['./view-feedback.component.scss']
})

export class ViewFeedbackComponent implements OnInit {
    // Data
    feedbackData: Feedback = {};
    feedbackID = '';
    feedbackLoaded = false;

    // Subscriptions
    subscriptions = [];
    routeSub: any;

    constructor(private feedbackService: FeedbackService,
                private route: ActivatedRoute,
                public currentUserData: CurrentUserDataService) {
    }

    ngOnInit(): void {
        this.routeSub = this.route.params.subscribe(params => {
            this.feedbackID = params.id;
            this.getFeedbackData(this.feedbackID);
        });
    }

    getFeedbackData(id) {
        this.feedbackService.getFeedbackById(id).subscribe(data => {
            this.feedbackData = data;

            if (data !== null) {
                this.feedbackLoaded = true;
                
            }
        });
    }
}
